import type { IconData } from '@stacksjs/iconify-core'

export const batteryEmpty: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M39.986 424H408a23.825 23.825 0 0 0 24-23.59V344h64V176h-64v-56.41A23.825 23.825 0 0 0 408 96H39.986a23.825 23.825 0 0 0-24 23.59v280.82a23.825 23.825 0 0 0 24 23.59m8-296H400v80h64v104h-64v80H47.986Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default batteryEmpty
